import le, { useRef as re, useLayoutEffect as ce, useState as Y, useCallback as ue, useEffect as ee } from "react";
var X = { exports: {} }, D = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ne;
function de() {
  if (ne) return D;
  ne = 1;
  var i = Symbol.for("react.transitional.element"), a = Symbol.for("react.fragment");
  function u(n, f, h) {
    var T = null;
    if (h !== void 0 && (T = "" + h), f.key !== void 0 && (T = "" + f.key), "key" in f) {
      h = {};
      for (var j in f)
        j !== "key" && (h[j] = f[j]);
    } else h = f;
    return f = h.ref, {
      $$typeof: i,
      type: n,
      key: T,
      ref: f !== void 0 ? f : null,
      props: h
    };
  }
  return D.Fragment = a, D.jsx = u, D.jsxs = u, D;
}
var F = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oe;
function fe() {
  return oe || (oe = 1, process.env.NODE_ENV !== "production" && function() {
    function i(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === g ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case R:
          return "Fragment";
        case H:
          return "Profiler";
        case k:
          return "StrictMode";
        case Z:
          return "Suspense";
        case U:
          return "SuspenseList";
        case Q:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case z:
            return "Portal";
          case l:
            return (e.displayName || "Context") + ".Provider";
          case B:
            return (e._context.displayName || "Context") + ".Consumer";
          case v:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case q:
            return t = e.displayName || null, t !== null ? t : i(e.type) || "Memo";
          case m:
            t = e._payload, e = e._init;
            try {
              return i(e(t));
            } catch {
            }
        }
      return null;
    }
    function a(e) {
      return "" + e;
    }
    function u(e) {
      try {
        a(e);
        var t = !1;
      } catch {
        t = !0;
      }
      if (t) {
        t = console;
        var r = t.error, o = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r.call(
          t,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          o
        ), a(e);
      }
    }
    function n(e) {
      if (e === R) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === m)
        return "<...>";
      try {
        var t = i(e);
        return t ? "<" + t + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function f() {
      var e = $.A;
      return e === null ? null : e.getOwner();
    }
    function h() {
      return Error("react-stack-top-frame");
    }
    function T(e) {
      if (E.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function j(e, t) {
      function r() {
        w || (w = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          t
        ));
      }
      r.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: r,
        configurable: !0
      });
    }
    function W() {
      var e = i(this.type);
      return I[e] || (I[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function G(e, t, r, o, b, x, P, N) {
      return r = x.ref, e = {
        $$typeof: C,
        type: e,
        key: t,
        props: x,
        _owner: b
      }, (r !== void 0 ? r : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: W
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: P
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: N
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function O(e, t, r, o, b, x, P, N) {
      var s = t.children;
      if (s !== void 0)
        if (o)
          if (A(s)) {
            for (o = 0; o < s.length; o++)
              M(s[o]);
            Object.freeze && Object.freeze(s);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else M(s);
      if (E.call(t, "key")) {
        s = i(e);
        var y = Object.keys(t).filter(function(V) {
          return V !== "key";
        });
        o = 0 < y.length ? "{key: someKey, " + y.join(": ..., ") + ": ...}" : "{key: someKey}", p[s + o] || (y = 0 < y.length ? "{" + y.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          o,
          s,
          y,
          s
        ), p[s + o] = !0);
      }
      if (s = null, r !== void 0 && (u(r), s = "" + r), T(t) && (u(t.key), s = "" + t.key), "key" in t) {
        r = {};
        for (var J in t)
          J !== "key" && (r[J] = t[J]);
      } else r = t;
      return s && j(
        r,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), G(
        e,
        s,
        x,
        b,
        f(),
        r,
        P,
        N
      );
    }
    function M(e) {
      typeof e == "object" && e !== null && e.$$typeof === C && e._store && (e._store.validated = 1);
    }
    var L = le, C = Symbol.for("react.transitional.element"), z = Symbol.for("react.portal"), R = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), H = Symbol.for("react.profiler"), B = Symbol.for("react.consumer"), l = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), U = Symbol.for("react.suspense_list"), q = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), Q = Symbol.for("react.activity"), g = Symbol.for("react.client.reference"), $ = L.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, E = Object.prototype.hasOwnProperty, A = Array.isArray, _ = console.createTask ? console.createTask : function() {
      return null;
    };
    L = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var w, I = {}, S = L.react_stack_bottom_frame.bind(
      L,
      h
    )(), c = _(n(h)), p = {};
    F.Fragment = R, F.jsx = function(e, t, r, o, b) {
      var x = 1e4 > $.recentlyCreatedOwnerStacks++;
      return O(
        e,
        t,
        r,
        !1,
        o,
        b,
        x ? Error("react-stack-top-frame") : S,
        x ? _(n(e)) : c
      );
    }, F.jsxs = function(e, t, r, o, b) {
      var x = 1e4 > $.recentlyCreatedOwnerStacks++;
      return O(
        e,
        t,
        r,
        !0,
        o,
        b,
        x ? Error("react-stack-top-frame") : S,
        x ? _(n(e)) : c
      );
    };
  }()), F;
}
var ie;
function pe() {
  return ie || (ie = 1, process.env.NODE_ENV === "production" ? X.exports = de() : X.exports = fe()), X.exports;
}
var d = pe(), me = process.env.NODE_ENV === "production", te = "Invariant failed";
function se(i, a) {
  if (!i) {
    if (me)
      throw new Error(te);
    var u = typeof a == "function" ? a() : a, n = u ? "".concat(te, ": ").concat(u) : te;
    throw new Error(n);
  }
}
function xe(i) {
  const a = re(null);
  return ce(() => {
    if (!a.current)
      return;
    const u = new ResizeObserver((n) => {
      se(n[0], "ResizeObserver should have at least one entry"), i(n[0].contentRect.width);
    });
    return u.observe(a.current), i(a.current.getBoundingClientRect().width), () => {
      u.disconnect();
    };
  }, [i]), a;
}
function he(i, a, u, n) {
  const f = n === "taller" ? Math.max(a, u) : Math.min(a, u);
  return i * f;
}
function ae(i) {
  return i.naturalHeight / i.naturalWidth;
}
const ge = (i) => {
  const {
    aspectRatio: a = "taller",
    handle: u = null,
    handleSize: n = 40,
    hover: f = !1,
    leftImage: h,
    leftImageAlt: T = "",
    leftImageCss: j = {},
    leftImageLabel: W = null,
    onSliderPositionChange: G,
    rightImage: O,
    rightImageAlt: M = "",
    rightImageCss: L = {},
    rightImageLabel: C = null,
    skeleton: z = null,
    sliderLineColor: R = "#ffffff",
    sliderLineWidth: k = 2,
    sliderPositionPercentage: H = 0.5,
    vertical: B = !1
  } = i, l = !B, [v, Z] = Y(
    H
  ), [U, q] = Y(!1), [m, Q] = Y(0), [g, $] = Y(0), E = xe((p) => Q(p)), A = re(null), _ = re(null), [w, I] = Y(!1), S = ue(() => {
    _.current?.complete && A.current?.complete && I(!0);
  }, []);
  ee(() => (S(), () => {
    I(!1);
  }), [h, O, S]), ee(() => {
    if (!(_.current && A.current) || m === 0 || !w)
      return;
    const p = he(
      m,
      ae(_.current),
      ae(A.current),
      a
    );
    $(p);
  }, [m, w, a]), ee(() => {
    if (!E.current || !w)
      return;
    const p = (o) => {
      if (!E.current)
        return;
      const b = E.current.getBoundingClientRect();
      let x, P;
      if (o instanceof TouchEvent) {
        const K = o.touches[0];
        se(K), x = K.clientX, P = K.clientY;
      } else
        x = o.clientX, P = o.clientY;
      const N = l ? x - b.left : P - b.top, s = k / 2, y = l ? m - s : g - s, V = Math.min(
        Math.max(N, s),
        y
      ) / (l ? m : g);
      Z(V), G?.(V);
    }, e = (o) => {
      q(!0), "touches" in o || o.preventDefault(), p(o), window.addEventListener("mousemove", p), window.addEventListener("touchmove", p);
    }, t = () => {
      q(!1), window.removeEventListener("mousemove", p), window.removeEventListener("touchmove", p);
    }, r = E.current;
    return r.addEventListener("touchstart", e), window.addEventListener("touchend", t), f ? (r.addEventListener("mousemove", p), r.addEventListener("mouseleave", t)) : (r.addEventListener("mousedown", e), window.addEventListener("mouseup", t)), () => {
      r.removeEventListener("touchstart", e), window.removeEventListener("touchend", t), r.removeEventListener("mousemove", p), r.removeEventListener("mouseleave", t), r.removeEventListener("mousedown", e), window.removeEventListener("mouseup", t), window.removeEventListener("mousemove", p), window.removeEventListener("touchmove", p);
    };
  }, [
    w,
    a,
    g,
    m,
    l,
    f,
    k,
    E
    // onSliderPositionChange, // may cause infinite loop
  ]);
  const c = {
    container: {
      boxSizing: "border-box",
      position: "relative",
      width: "100%",
      height: `${g}px`,
      overflow: "hidden"
    },
    rightImage: {
      clipPath: l ? `inset(0px 0px 0px ${m * v}px)` : `inset(${g * v}px 0px 0px 0px)`,
      display: "block",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      width: "100%",
      ...L
    },
    leftImage: {
      clipPath: l ? `inset(0px ${m * (1 - v)}px 0px 0px)` : `inset(0px 0px ${g * (1 - v)}px 0px)`,
      display: "block",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      width: "100%",
      ...j
    },
    slider: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      ...l ? {
        cursor: "ew-resize",
        flexDirection: "column",
        height: "100%",
        left: `${m * v - n / 2}px`,
        top: 0,
        width: `${n}px`
      } : {
        cursor: "ns-resize",
        flexDirection: "row",
        height: `${n}px`,
        left: 0,
        top: `${g * v - n / 2}px`,
        width: "100%"
      }
    },
    line: {
      background: R,
      boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
      flex: "0 1 auto",
      height: l ? "100%" : `${k}px`,
      width: l ? `${k}px` : "100%"
    },
    handleCustom: {
      alignItems: "center",
      boxSizing: "border-box",
      display: "flex",
      flex: "1 0 auto",
      height: "auto",
      justifyContent: "center",
      width: "auto"
    },
    handleDefault: {
      alignItems: "center",
      border: `${k}px solid ${R}`,
      borderRadius: "100%",
      boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
      boxSizing: "border-box",
      display: "flex",
      flex: "1 0 auto",
      height: `${n}px`,
      justifyContent: "center",
      width: `${n}px`,
      transform: l ? "none" : "rotate(90deg)"
    },
    leftArrow: {
      border: `inset ${n * 0.15}px rgba(0,0,0,0)`,
      borderRight: `${n * 0.15}px solid ${R}`,
      height: "0px",
      marginLeft: `-${n * 0.25}px`,
      // for IE11
      marginRight: `${n * 0.25}px`,
      width: "0px"
    },
    rightArrow: {
      border: `inset ${n * 0.15}px rgba(0,0,0,0)`,
      borderLeft: `${n * 0.15}px solid ${R}`,
      height: "0px",
      marginRight: `-${n * 0.25}px`,
      // for IE11
      width: "0px"
    },
    leftLabel: {
      background: "rgba(0, 0, 0, 0.5)",
      color: "white",
      left: l ? "5%" : "50%",
      opacity: U ? 0 : 1,
      padding: "10px 20px",
      position: "absolute",
      top: l ? "50%" : "3%",
      transform: l ? "translate(0,-50%)" : "translate(-50%, 0)",
      transition: "opacity 0.1s ease-out"
    },
    rightLabel: {
      background: "rgba(0, 0, 0, 0.5)",
      color: "white",
      opacity: U ? 0 : 1,
      padding: "10px 20px",
      position: "absolute",
      ...l ? {
        right: "5%",
        top: "50%",
        transform: "translate(0,-50%)"
      } : {
        left: "50%",
        bottom: "3%",
        transform: "translate(-50%, 0)"
      },
      transition: "opacity 0.1s ease-out"
    },
    leftLabelContainer: {
      clipPath: l ? `inset(0px ${m * (1 - v)}px 0px 0px)` : `inset(0px 0px ${g * (1 - v)}px 0px)`,
      height: "100%",
      position: "absolute",
      width: "100%"
    },
    rightLabelContainer: {
      clipPath: l ? `inset(0px 0px 0px ${m * v}px)` : `inset(${g * v}px 0px 0px 0px)`,
      height: "100%",
      position: "absolute",
      width: "100%"
    }
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    z && !w && /* @__PURE__ */ d.jsx("div", { style: { ...c.container }, children: z }),
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        style: {
          ...c.container,
          display: w ? "block" : "none"
        },
        ref: E,
        "data-testid": "container",
        children: [
          /* @__PURE__ */ d.jsx(
            "img",
            {
              onLoad: () => S(),
              alt: M,
              "data-testid": "right-image",
              ref: A,
              src: O,
              style: c.rightImage
            }
          ),
          /* @__PURE__ */ d.jsx(
            "img",
            {
              onLoad: () => S(),
              alt: T,
              "data-testid": "left-image",
              ref: _,
              src: h,
              style: c.leftImage
            }
          ),
          /* @__PURE__ */ d.jsxs("div", { style: c.slider, children: [
            /* @__PURE__ */ d.jsx("div", { style: c.line }),
            u ? /* @__PURE__ */ d.jsx("div", { style: c.handleCustom, children: u }) : /* @__PURE__ */ d.jsxs("div", { style: c.handleDefault, children: [
              /* @__PURE__ */ d.jsx("div", { style: c.leftArrow }),
              /* @__PURE__ */ d.jsx("div", { style: c.rightArrow })
            ] }),
            /* @__PURE__ */ d.jsx("div", { style: c.line })
          ] }),
          W && /* @__PURE__ */ d.jsx("div", { style: c.leftLabelContainer, children: /* @__PURE__ */ d.jsx("div", { style: c.leftLabel, children: W }) }),
          C && /* @__PURE__ */ d.jsx("div", { style: c.rightLabelContainer, children: /* @__PURE__ */ d.jsx("div", { style: c.rightLabel, children: C }) })
        ]
      }
    )
  ] });
};
export {
  ge as default
};
